import React, { forwardRef, PropsWithChildren } from 'react';

import clsx from 'clsx';

import classes from './container.module.scss';

export type ContainerProps = PropsWithChildren<{
  fluid?: boolean;
  tighter?: boolean;
  tiny?: boolean;
  className?: string;
}>;

type Props = ContainerProps;

export const Container = forwardRef<HTMLDivElement, Props>(
  ({ children, fluid, tighter, tiny, className }, ref) => (
    <div
      className={clsx(
        classes.container,
        fluid && classes.fluid,
        tighter && classes.tighter,
        tiny && classes.tiny,
        className,
      )}
      ref={ref}
    >
      {children}
    </div>
  ),
);
